import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'MR',
  name: 'Marta R.',
  location: 'Mendoza',
  plan: 'Megapack Completo',
  quote: 'Armé medialunas para el desayuno del domingo. Mi familia no podía creer que eran sin gluten y sin azúcar. Yo tampoco podía creer que las hice yo.'
}, {
  initials: 'EB',
  name: 'Elena B.',
  location: 'Buenos Aires',
  plan: 'Megapack + Masterclass',
  quote: 'Llevé una torta al cumpleaños de mi nieta. Nadie notó nada. Me pidieron la receta. Tuve que confesarles que era sin azúcar y sin gluten.'
}, {
  initials: 'CG',
  name: 'Carmen G.',
  location: 'Córdoba',
  plan: 'Megapack Completo',
  quote: 'Lo que más me sorprendió fue lo fácil que es. Los ingredientes los conseguí en el chino de la esquina. Pensé que necesitaba ir a una dietética especial. Para nada.'
}, {
  initials: 'NF',
  name: 'Nora F.',
  location: 'Rosario',
  plan: 'Megapack + Masterclass',
  quote: 'Logré hacer masa madre sin gluten desde cero. El pan me salió con una miga aireada que nunca había podido conseguir. La técnica de fermentación larga cambió todo.'
}, {
  initials: 'SP',
  name: 'Susana P.',
  location: 'Santa Fe',
  plan: 'Megapack Completo',
  quote: 'Hice la pizza del sábado con toda la familia. Todos comieron lo mismo. Por primera vez en dos años no me sentí la enferma de la mesa.'
}];
export function Testimonials() {
  return <section className="py-16 sm:py-20 px-4 bg-brand-base border-t border-brand-gold/15 relative overflow-hidden" data-id="element-254">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-255"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-brand-gold/10 blur-[120px] rounded-full pointer-events-none" data-id="element-256"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-257">
        <div className="mb-12 flex flex-col items-center text-center" data-id="element-258">
          <span className="text-3xl sm:text-4xl mb-3" aria-hidden data-id="element-259">
            ❤️
          </span>
          <h2 className="font-display font-extrabold text-brand-gold text-[26px] sm:text-[40px] max-w-[22ch] tracking-tight glow-gold leading-tight" data-id="element-260">
            Mujeres como vos que ya volvieron a la mesa sin miedo
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-261">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-ink/70 backdrop-blur-sm p-6 rounded-3xl flex flex-col items-center h-full border border-brand-gold/25" style={{
          boxShadow: '0 20px 40px -20px rgba(0,0,0,0.6), inset 0 1px 0 rgba(212,168,67,0.1)'
        }} data-id="element-262">
              <div className="flex gap-1 mb-4 text-brand-gold" data-id="element-263">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" strokeWidth={0} data-id="element-264" />)}
              </div>

              <p className="text-brand-cream/85 italic mb-6 text-sm leading-relaxed flex-grow text-center" data-id="element-265">
                <span className="text-brand-gold font-bold" data-id="element-266">✦ "</span>
                {t.quote}
                <span className="text-brand-gold font-bold" data-id="element-267">" ✦</span>
              </p>

              <div className="gold-divider w-2/3 mb-5" data-id="element-268"></div>

              <div className="flex flex-col items-center gap-2" data-id="element-269">
                <div className="w-12 h-12 rounded-full bg-brand-gold text-brand-base flex items-center justify-center font-extrabold text-base" data-id="element-270">
                  {t.initials}
                </div>
                <div className="text-center" data-id="element-271">
                  <p className="font-extrabold text-brand-gold text-base glow-gold" data-id="element-272">
                    ✦ {t.name} ✦
                  </p>
                  <p className="text-xs text-brand-cream/65 mt-1" data-id="element-273">
                    📍 {t.location}
                  </p>
                  <p className="text-[11px] text-brand-gold/80 italic mt-0.5" data-id="element-274">
                    {t.plan}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}